import { ELinkButtonVariant, ETextStyleVariant, LinkButton, Text } from '@outdoorsyco/bonfire';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { EFilterCategories } from '@/constants/searchFilters';

import { useFilterPillsCtx } from '../FilterPillsContext/FilterPillsContext';

export const EstimatedMileageBanner: React.FC = () => {
  const intl = useIntl();
  const { openModalFilter } = useFilterPillsCtx();

  const handleChangeMileage = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      openModalFilter(EFilterCategories.TYPE);
    },
    [openModalFilter],
  );

  return (
    <div className="flex items-center px-4 py-4 bg-white border-b gap-6 border-neutral-20 xl:pr-10 xl:pl-16 sm:px-10">
      <Text variant={ETextStyleVariant.SmallRegular}>
        <FormattedMessage
          id="FBCCmK"
          defaultMessage="Estimated price includes mileage."
          description="Search > Estimated Mileage Banner > Banner text"
        />
      </Text>
      <LinkButton
        href="#"
        label={intl.formatMessage({ id: 'Ewug2m', defaultMessage: 'Change mileage' })}
        variant={ELinkButtonVariant.Underline}
        className="text-sm leading-8"
        onClick={handleChangeMileage}
      />
    </div>
  );
};
